
(() => {
  if (window.LeathvoraTitanProductZoom) return;
  window.LeathvoraTitanProductZoom = true;

  const finePointer = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  const upgradeLightboxClasses = (opener) => {
    const toggle = opener.querySelector('.product__media-toggle');
    if (toggle && toggle.classList.contains('product__media-zoom-none')) {
      toggle.classList.remove('product__media-zoom-none');
      toggle.classList.add('product__media-zoom-lightbox');
    }

    const icon = opener.querySelector('.product__media-icon');
    if (icon && icon.classList.contains('product__media-icon--none')) {
      icon.classList.remove('product__media-icon--none');
      icon.classList.add('product__media-icon--lightbox');
    }
  };

  const bindOpener = (opener) => {
    if (!(opener instanceof HTMLElement) || opener.dataset.lvTitanZoomReady === 'true') return;
    const image = opener.querySelector('.product__media img');
    if (!image) return;

    opener.dataset.lvTitanZoomReady = 'true';
    upgradeLightboxClasses(opener);

    let frame = null;

    const reset = () => {
      opener.classList.remove('lv-image-zooming');
      opener.style.removeProperty('--lv-zoom-x');
      opener.style.removeProperty('--lv-zoom-y');
    };

    const move = (event) => {
      if (!finePointer.matches) {
        reset();
        return;
      }

      frame = frame || opener.querySelector('.product__media') || opener;
      const rect = frame.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));

      opener.style.setProperty('--lv-zoom-x', x.toFixed(2) + '%');
      opener.style.setProperty('--lv-zoom-y', y.toFixed(2) + '%');
      opener.classList.add('lv-image-zooming');
    };

    opener.addEventListener('pointerenter', move, { passive: true });
    opener.addEventListener('pointermove', move, { passive: true });
    opener.addEventListener('pointerleave', reset, { passive: true });
    opener.addEventListener('pointercancel', reset, { passive: true });

    finePointer.addEventListener?.('change', reset);
  };

  const init = (root = document) => {
    root.querySelectorAll?.('[id^="MainProduct-"] .product__modal-opener--image').forEach(bindOpener);
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('[id^="MainProduct-"], .product__modal-opener--image')) init(node.parentElement || node);
        else if (node.querySelector?.('[id^="MainProduct-"] .product__modal-opener--image')) init(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  init(document);
})();
